module.exports = __webpack_public_path__ + "img/Grejanje_KEROSENE.bcc38e8b.svg";